import * as React from 'react'
import { FC, useEffect } from 'react'
import { size } from '../../../../style/media'
import useDimensions from '../../../../helpers/useDimensions'
import DesktopMenu from './DesktopMenu'
import MobileMenu from './MobileMenu'
import { getEnabledLinks, Tier1Link, Link } from '../../../../helpers/navStructure'

interface MenuProps {
  isOpen: boolean
  onClose: () => void
  selectedLink: Tier1Link | null
  onSelectedLink: (link: Tier1Link | null) => void
  highlightedTier2Link: Link | null
  onHighlightedTier2Link: (link: Link | null) => void
  highlightedTier3Link: Link | null
  onHighlightedTier3Link: (link: Link | null) => void
}

const Menu: FC<MenuProps> = ({
  isOpen,
  onClose,
  selectedLink,
  onSelectedLink,
  highlightedTier2Link,
  onHighlightedTier2Link,
  highlightedTier3Link,
  onHighlightedTier3Link,
}) => {
  const links = getEnabledLinks()
  const [menuElement, dimensions] = useDimensions<HTMLDivElement>()

  const isDesktop = dimensions.width >= size.tabletMin

  useEffect(() => {
    if (isDesktop) {
      document.body.style.overflowY = isOpen ? 'hidden' : 'auto'
      return (): void => {
        document.body.style.overflowY = 'auto'
      }
    }
    return () => {}
  }, [isOpen, isDesktop])

  return (
    <div ref={menuElement}>
      {isDesktop ? (
        <DesktopMenu
          links={links}
          isOpen={isOpen}
          onClose={onClose}
          selectedLink={selectedLink}
          onSelectedLink={onSelectedLink}
          highlightedTier2Link={highlightedTier2Link}
          onHighlightedTier2Link={onHighlightedTier2Link}
          highlightedTier3Link={highlightedTier3Link}
          onHighlightedTier3Link={onHighlightedTier3Link}
        />
      ) : (
        <MobileMenu
          childLinks={links}
          isOpen={isOpen}
          onClose={onClose}
          selectedLink={selectedLink}
          onSelectedLink={onSelectedLink}
          highlightedTier2Link={highlightedTier2Link}
          onHighlightedTier2Link={onHighlightedTier2Link}
          highlightedTier3Link={highlightedTier3Link}
          onHighlightedTier3Link={onHighlightedTier3Link}
        />
      )}
    </div>
  )
}

export default Menu
